<template>
  <div data-qa="carddetails-div-34smjl">
    <v-flex v-if="cardType === 'credit'" data-qa="carddetails-flex-3gpenm">
      <CreditDetails
        :config="{
          params: {
            cardId,
            cardName,
            cardBalance,
            cardCurrency,
            cardMaskedNumber,
            cardStatus,
          },
        }"
      />
    </v-flex>
    <v-flex v-if="cardType === 'debit'" data-qa="carddetails-flex-rqmstv">
      <DebitDetails
        :config="{
          params: {
            cardId,
            cardAccountNumber,
            cardName,
            cardMaskedNumber
          },
        }"
      />
    </v-flex>
    <v-flex class="my-4" data-qa="carddetails-flex-ilw84g">
      <v-divider data-qa="carddetails-divider-0180t"></v-divider>
    </v-flex>
    <v-flex class="mb-1" v-if="tips.enabled" data-qa="carddetails-flex-hxgdi">
      <v-alert
        icon="mdi-information-outline"
        class="v-alert--info"
        v-for="(tip, i) in tips.tipMessages"
        :key="tip"
        :data-qa="`carddetails-alert-h0gdi-${i}`"
      >
        <font class="body-2 font-weight-regular">
          {{ $t(`screenTips.${tip}`) }}
        </font>
      </v-alert>
    </v-flex>
  </div>
</template>

<script>
import CreditDetails from '@/views/cards/cardDetails/CreditDetails'
import DebitDetails from '@/views/cards/cardDetails/DebitDetails'

export default {
  name: 'CardDetails',
  components: {
    CreditDetails,
    DebitDetails
  },
  data () {
    return {
      tips: {
        enabled: false,
        tipMessages: []
      },
      cardType: ''
    }
  },
  beforeMount () {
    if (!this.cardId) {
      this.goBack()
    }
  },
  created () {
    if (this.$route.params) {
      this.cardType = this.$route.params.cardType
        ? this.$route.params.cardType
        : ''
      this.cardId = this.$route.params.cardId ? this.$route.params.cardId : ''
      this.cardName = this.$route.params.cardName
        ? this.$route.params.cardName
        : ''
      this.cardMaskedNumber = this.$route.params.cardMaskedNumber
        ? this.$route.params.cardMaskedNumber
        : ''
      this.cardBalance = this.$route.params.cardBalance
        ? this.$route.params.cardBalance
        : ''
      this.cardCurrency = this.$route.params.cardCurrency
        ? this.$route.params.cardCurrency
        : ''
      this.cardProductName = this.$route.params.cardProductName
        ? this.$route.params.cardProductName
        : ''
      this.cardStatus = this.$route.params.cardStatus
        ? this.$route.params.cardStatus
        : ''
      this.cardExpiryDate = this.$route.params.cardExpiryDate
        ? this.$route.params.cardExpiryDate
        : ''
      this.cardAccountNumber = this.$route.params.cardAccountNumber
        ? this.$route.params.cardAccountNumber
        : ''
      this.navToTab = this.$route.params.navToTab || 0
    }
    if (!this.cardId) {
      this.$router.push('Home')
    }
    this.setTips(this.cardType)
  },
  methods: {
    goBack () {
      return this.$router.go(-1)
    },
    setTips (cardType) {
      if (cardType === 'credit') {
        this.tips = this.$appSettings.screenTips.credit
      } else {
        this.tips = this.$appSettings.screenTips.debit
      }
    }
  }
}
</script>
